export default {
  title: 'Join our Rewards Club!',
  form: {
    phone_number: {
      label: 'Phone number',
      description: 'We need your phone number, so that we can make sure you are the right person that we reward',
      placeholder: 'Phone number',
    },
    birthday: {
      label: 'Birthday: Day and month is enough to get a bday gift 🥳',
      placeholder: 'Birthday (optional)',
      parts: {
        month: 'Month',
        day: 'Day',
      },
    },
  },
  benefits: {
    earn_points: 'Earn points with every order',
    get_deals: 'Get exclusive deals',
    redeem_points: 'Redeem points for discounts',
  },
  terms:
    'By registering, you agree to our <TermsLink>terms and conditions</TermsLink> and consent to our <PrivacyPolicyLink>privacy policy</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Continue',
  },
  toasts: {
    login_success: 'You have been successfully logged in',
    invalid_code: 'Invalid code. Please try again.',
    failed_to_update_profile: 'Failed to update profile. Please try again.',
  },
};
